import api from '../../api/client';

export type DurationUnit = 'day' | 'month' | 'year';
export type PaymentStatus = 'pending' | 'approved' | 'rejected';

export interface SubscriptionPlan {
  id: number;
  name: string;
  /** Shu do'kon uchun narx (maxsus narx bo'lsa o'sha). */
  price: string;
  base_price: string;
  duration_value: number;
  duration_unit: DurationUnit;
  duration_label: string;
}

export interface SubscriptionPaymentItem {
  id: number;
  kind: 'payment' | 'free';
  plan_name: string;
  duration_label: string;
  expected_amount: string;
  amount: string;
  has_receipt: boolean;
  note: string;
  status: PaymentStatus;
  rejection_reason: string;
  period_start: string | null;
  period_end: string | null;
  reviewed_at: string | null;
  created_at: string;
}

export interface SubscriptionState {
  active: boolean;
  until: string;
  days_left: number;
  can_pay: boolean;
  has_pending: boolean;
  plans: SubscriptionPlan[];
  requisites: { card_number: string; card_holder: string; note: string };
  payments: SubscriptionPaymentItem[];
}

export const subscriptionApi = {
  get: () => api.get<SubscriptionState>('/subscription/'),
  pay: (data: { plan: number; amount: string; receipt: File; note?: string }) => {
    const form = new FormData();
    form.append('plan', String(data.plan));
    form.append('amount', data.amount);
    form.append('receipt', data.receipt);
    if (data.note) form.append('note', data.note);
    // Chek rasmi sekin internetda uzoq yuklanishi mumkin.
    return api.post<SubscriptionState>('/subscription/', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    });
  },
  receipt: (id: number) =>
    api.get<Blob>(`/subscription/receipts/${id}/`, { responseType: 'blob', timeout: 60000 }),
};
